/**
 * @flow
 * */
import { put, takeLatest } from 'redux-saga/effects';

import ActivityLogSDK from 'modules/Admin/ActivityLog/core/sdk/ActivityLogSDK';
import ACTIONS from 'modules/Admin/ActivityLog/store/actions/types';
import { parseDataWithTotalCount } from 'lib/helpers/parser';
import {
  setFetchActivityLogsFailure,
  setFetchActivityLogsSuccess
} from 'modules/Admin/ActivityLog/store/actions';

class ActivityLogController {
  static* fetchActivityLogs({ payload }) {
    const { filters } = payload;
    try {
      const response = yield ActivityLogSDK.getActivityLogs(filters);
      const { data, totalCount } = parseDataWithTotalCount(response);
      yield put(setFetchActivityLogsSuccess({ data, totalCount, passTotalCount: filters.skipTotalCount }));
    } catch (err) {
      if (err.name === 'AbortError') return;
      yield put(setFetchActivityLogsFailure(err.message));
    }
  }

  static* cancelActivityLogCall({ payload }) {
    const { name } = payload;
    yield ActivityLogSDK.cancelActivityLogSDKCalls({ name });
  }

  static* actionsWatcher(): Object {
    yield takeLatest(ACTIONS.FETCH_ACTIVITY_LOGS, ActivityLogController.fetchActivityLogs);
    yield takeLatest(ACTIONS.CANCEL_ACTIVITY_LOG_SDK_CALL, ActivityLogController.cancelActivityLogCall);
  }
}

export default ActivityLogController.actionsWatcher;
